import { Heading, Layout } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { CurrentlySelected } from "../components/dealer-selection/CurrentlySelected";
import { SearchDealer } from "../components/dealer-selection/SearchDealer";
import { DealerSearchResult } from "../components/dealer-selection/DealerSearchResult";
import { SaveAndContinue } from "../components/save-and-continue/SaveAndContinue";

export const DealerSelectionPage = () => {
    const { t } = useTranslation(["matchmakerwizard", "dealerselection"]);
    const brand = process.env.REACT_APP_WEBSITE_BRAND; 

    return (
        <Layout>
            <Layout.Item>
                <Heading className="u-mt-xlarge u-font-size-fs2 " level={2}>
                    {brand === "audi" ? t("dealerselection:page-titleAudi"): t("dealerselection:page-title")}
                </Heading>
            </Layout.Item>
            <CurrentlySelected />
            <SearchDealer />
            <DealerSearchResult />
            <SaveAndContinue />
        </Layout>
    );
};
